import styled, { css } from 'styled-components';
import { rem, ellipsis } from 'polished';

const ElementTooltip = styled.span`
  display: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  position: relative;
  font-size: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  position: relative;

  &:after {
    background: ${props => props.theme.colors.graySad};
    border-radius: ${rem('4px')};
    bottom: ${rem('43px')};
    color: ${props => props.theme.colors.light};
    content: attr(data-text);
    display: block;
    font-family: ${props => props.theme.fonts.medium};
    font-size: ${rem('12px')};
    left: 0;
    line-height: 1.1;
    opacity: 0;
    padding: 1rem;
    position: absolute;
    transition: opacity 0.2s ease;
    visibility: hidden;
    width: 100%;
  }

  &:before {
    border-left: ${rem('8px')} solid transparent;
    border-right: ${rem('8px')} solid transparent;
    border-top: ${rem('8px')} solid ${props => props.theme.colors.graySad};
    bottom: ${rem('35px')};
    content: '';
    height: 0;
    left: calc(50% - ${rem('8px')});
    opacity: 0;
    position: absolute;
    right: calc(50% - ${rem('8px')});
    transition: opacity 0.2s ease;
    visibility: hidden;
    width: 0;
  }

  &:hover {
    cursor: pointer;
  }

  ${props =>
    props.isVisible &&
    css`
      &:hover,
      &:focus {
        &:before,
        &:after {
          opacity: 1;
          visibility: visible;
          z-index: 10;
        }
      }
    `}

  ${props =>
    props.bottom &&
    css`
      &:after {
        bottom: auto;
        top: ${rem('43px')};
      }

      &:before {
        border-top: 0;
        border-left: ${rem('8px')} solid transparent;
        border-right: ${rem('8px')} solid transparent;
        border-bottom: ${rem('8px')} solid
          ${props => props.theme.colors.graySad};
        bottom: auto;
        top: ${rem('35px')};
      }
    `};
`;

const TextEllipsis = styled.span`
  ${ellipsis()};
  display: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;

  ${props =>
    props.width &&
    `
    max-width: ${props.width};
  `};
`;

export { ElementTooltip, TextEllipsis };
